// extracted by mini-css-extract-plugin
export default {"wrapper":"ui_wrapper__sl8vD","wrapperLoader":"ui_wrapperLoader__CJE36","checkSignSuccess":"ui_checkSignSuccess__kIWlK","qrWrapper":"ui_qrWrapper__o-N6y"};